module.exports = __webpack_public_path__ + "img/process-bg-bf.8acf10e6.png";